((window) => {
  const ReadMore = function ($read_more) {
    if (typeof $read_more !== 'object' || !$read_more.nodeName) {
      return false;
    }

    this.$read_more = $read_more;
    this.$read_more_close = this.$read_more.querySelector('.read-more__wrapper--closed');
    this.$read_more_open = this.$read_more.querySelector('.read-more__wrapper--open');
    this.$read_more_btn = this.$read_more.querySelectorAll('.read-more__btn');

    this.close();

    for (let i = this.$read_more_btn.length - 1; i >= 0; i--) {
      this.$read_more_btn[i].addEventListener(
        'click',
        function () {
          if (this.$read_more.classList.contains('is-open')) {
            this.close();
          } else {
            this.open();
          }
        }.bind(this),
      );
    }
  };

  ReadMore.prototype.open = function () {
    this.$read_more.classList.remove('is-closed');
    this.$read_more.classList.add('is-open');
    this.$read_more_close.setAttribute('aria-hidden', 'true');
    this.$read_more_open.setAttribute('aria-hidden', 'false');
  };

  ReadMore.prototype.close = function () {
    this.$read_more.classList.remove('is-open');
    this.$read_more.classList.add('is-closed');
    this.$read_more_close.setAttribute('aria-hidden', 'false');
    this.$read_more_open.setAttribute('aria-hidden', 'true');
  };

  window.ReadMore = ReadMore;
})(window);
